module.exports = __webpack_public_path__ + "static/media/icon_calender.5b0fd8e0.svg";